import { useEffect } from 'react';
import { atom, useRecoilState } from 'recoil';

import { CHAINS_LIST } from '@/utils';
import { getQueryParam } from '@/utils/location';

const _queryChain = getQueryParam('chain');

// keep a page use same chain
const pageChainAtom = atom({
  key: 'pageChainAtom',
  default: (_queryChain as string) || '',
});

export const getChain = (chainId: string) => {
  const chain = CHAINS_LIST.find(item => item.id === parseInt(chainId))?.serverId;

  return chain;
};

const currentChainAtom = atom<string | undefined>({
  key: 'currentChainAtom',
  default: undefined,
  effects_UNSTABLE: [
    ({ setSelf, trigger }) => {
      if (!window?.ethereum) {
        setSelf('');
        return;
      }

      const setChain = (_chainId?: string) => {
        window.ethereum
          .request({ method: 'eth_chainId' })
          .then((chainId: string) => {
            setSelf(getChain(chainId));
          })
          .catch(() => {
            if (_chainId) {
              setSelf(getChain(_chainId));
            }
          });
      };

      if (trigger === 'get') {
        setChain();
      }

      window.ethereum.on('chainChanged', setChain);

      return () => window.ethereum.removeEventListener?.('chainChanged', setChain);
    },
  ],
});

export const useCurrentChain = () => {
  return useRecoilState(currentChainAtom);
};

export const usePageChain = (resetOnUnmount?: boolean) => {
  const [chain, setChain] = useRecoilState(pageChainAtom);

  useEffect(() => {
    const _chain = getQueryParam('chain');
    if (chain !== _chain) {
      setChain(_chain as string);
    }
    return () => {
      if (resetOnUnmount) {
        setChain('');
      }
    };
    // eslint-disable-next-line
  }, [resetOnUnmount, setChain]);

  return [chain, setChain] as const;
};
